(function () {
  'use strict';

  var section = document.querySelector('[data-luxe-story]');
  if (!section) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (!gsap || !ST || reduce) return;

    gsap.registerPlugin(ST);
    if (window.SplitText) { try { gsap.registerPlugin(window.SplitText); } catch (e) {} }

    var heading = section.querySelector('[data-story-heading]');
    var para = section.querySelector('[data-story-text]');
    var figure = section.querySelector('[data-story-figure]');
    var media = section.querySelector('[data-story-media]');
    var SplitText = window.SplitText;

    section.classList.add('ls-ready');

    if (media && figure) {
      gsap.fromTo(media, { scale: 1.14 }, {
        scale: 1, ease: 'none',
        scrollTrigger: { trigger: figure, start: 'top bottom', end: 'bottom top', scrub: 0.6 }
      });
    }

    if (heading) {
      if (SplitText) {
        var hs = new SplitText(heading, { type: 'words', wordsClass: 'ls__hword' });
        gsap.set(hs.words, { yPercent: 120, opacity: 0 });
        gsap.to(hs.words, {
          yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.06,
          scrollTrigger: { trigger: heading, start: 'top 85%' }
        });
      } else {
        gsap.from(heading, {
          y: 40, opacity: 0, duration: 1, ease: 'power3.out',
          scrollTrigger: { trigger: heading, start: 'top 85%' }
        });
      }
    }

    if (para) {
      if (SplitText) {
        var ps = new SplitText(para, { type: 'words', wordsClass: 'ls__word' });
        gsap.set(ps.words, { color: 'rgba(242, 235, 221, 0.24)' });
        gsap.to(ps.words, {
          color: '#f5f0e7', ease: 'none', stagger: { each: 0.5 },
          scrollTrigger: { trigger: figure, start: 'top 62%', end: 'bottom 56%', scrub: 0.4 }
        });
      } else {
        para.style.color = 'var(--ls-ink)';
      }
    }

    ST.refresh();
  }

  function whenReady() {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
    else init();
  }

  if (document.readyState !== 'loading') whenReady();
  else document.addEventListener('DOMContentLoaded', whenReady);
})();
